import Api from './Api';
import resolve from  '../util/Configuracao';
class AuxilioSaudeApi extends Api {
  async consultarEstados () {
    try {
      const estadosAuxilioUrl = resolve('urlConsultarEstadosAuxilioSaude');
      const response = await this.fetch(estadosAuxilioUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarValorReferencia (codServidor, seqDependente, dataReferencia) {
    try {
      const urlValorReferenciaAuxilio = resolve('urlValorReferenciaAuxilio') + codServidor + '/' + seqDependente + '/' + dataReferencia;
      const response = await this.fetch(urlValorReferenciaAuxilio);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }  

  async consultarAuxilios (numProtocolo, codServidor, seqDependente, codEstado, dataInicial, dataFinal, mes, ano) {
    let auxilios = [];
    let brancoAcoes = '';
    let botaoHomologar = '';
    try {
      const auxilioUrl = resolve('urlConsultarAuxiliosSaude') +
      numProtocolo + '/' +
      codServidor + '/' +
      seqDependente + '/' +
      codEstado + '/' +
      dataInicial + '/' +
      dataFinal + '/' +
      mes + '/' +
      ano;
      const { data } = await this.fetch(auxilioUrl, 'post');
    data.map(res => {
      const { numProtocolo, codServidor, seqDependente, nomeBeneficiario, valPago, valReferencia, valAuxilio, codEstado, desEstado, txtObservacao, dtaCadastro, dtaReferencia, mesPag, anoPag, txtProcessoSei, dtaProcessamento } = res;
      if (codEstado === 1) {
        botaoHomologar = 'HOMOLOGAR';
      } 
      if (codEstado === 2) {
        botaoHomologar = 'DESFAZER';
      } 
      if (codEstado === 3) {
        botaoHomologar = 'NENHUM';
      } 
      auxilios.push(Object.values({ numProtocolo, codServidor, seqDependente, nomeBeneficiario, valPago, valReferencia, valAuxilio, codEstado, desEstado, txtObservacao, dtaCadastro, dtaReferencia, mesPag, anoPag, botaoHomologar, brancoAcoes, txtProcessoSei, dtaProcessamento }));
    });
    return auxilios || [];
    } catch (error) {
      console.error(error);
    }

  }
  async incluirAuxilio (auxilio) {
    try {
      const urlIncluirAuxilio = resolve('urlIncluirAuxilio');
      const response = await this.fetch(urlIncluirAuxilio, 'put', auxilio);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarAuxilio (auxilio) {
    try {
      const urlAlterarAuxilio = resolve('urlAlterarAuxilio');
      const response = await this.fetch(urlAlterarAuxilio, 'put', auxilio);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirAuxiliosEmLote (auxilios) {
    try {
      const urlExcluirAuxilios = resolve('urlExcluirAuxilios');
      const result = await this.fetch(urlExcluirAuxilios, 'post', auxilios);
      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }
  async homologarAuxilio (numProtocolo) {
    try {
      const urlHomologarAuxilio = resolve('urlHomologarAuxilio') + numProtocolo;
      const response = await this.fetch(urlHomologarAuxilio, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async desfazerHomologacaoAuxilio (numProtocolo) {
    try {
      const urlDesfazerHomologacaoAuxilio = resolve('urlDesfazerHomologacaoAuxilio') + numProtocolo;
      const response = await this.fetch(urlDesfazerHomologacaoAuxilio, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirAuxilio (numProtocolo) {
    try {
      const urlExcluirAuxilio = resolve('urlExcluirAuxilio') + numProtocolo;
      const response = await this.fetch(urlExcluirAuxilio, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
}
export default AuxilioSaudeApi;
